import React, { useState } from "react";
import "../../styles/components/Benefits.css";
import IconPng from "../../components/IconPng";

import Modal from "../../components/Modal";
import ContactFormSimple from "../../components/ContactFormSimple";

import tfBg from "../../img/background/background_4.png";
import cycleBg from "../../img/background/background_3.png";
import ctaBubble from "../../img/hero/arrow_2.png";

export default function KeyBenefits() {
  const [openModal, setOpenModal] = useState(false);

  return (
    <section className="kb">
      <h2 className="kb-heading kb-anim">Why teams choose us</h2>

      <div className="kb-row">
        <article className="kb-card kb-anim kb-card--lg kb-card--soft kb-card--badge-white">
          <img src={tfBg} alt="" aria-hidden="true" className="kb-bg kb-bg--tf" />

          <div className="kb-badges">
            <span className="kb-badge">
              <IconPng name="Globe-1" size={28} />
            </span>
            <span className="kb-badge">
              <IconPng name="Sparkle-2" size={28} />
            </span>
          </div>

          <h3 className="kb-title">Personalization at Scale</h3>
          <p className="kb-desc">
            Every user gets a unique experience. Context-aware agents drive
            retention, LTV, and engagement across your entire user base.
          </p>
        </article>

        <article className="kb-card kb-anim kb-card--md kb-card--outline kb-card--badge-tint kb-card--offset">
          <div className="kb-badges">
            <span className="kb-badge">
              <IconPng name="ChartLineUp" size={28} />
            </span>
            <span className="kb-badge">
              <IconPng name="Pulse-2" size={28} />
            </span>
          </div>

          <h3 className="kb-title">Metrics-Driven</h3>
          <p className="kb-desc">
            We optimize what matters: ARPU, LTV, retention, cost per creative,
            operational headcount. If it doesn’t move a metric, we don’t ship it.
          </p>
        </article>

        <article className="kb-card kb-anim kb-card--lg kb-card--soft kb-card--badge-white">
          <img src={cycleBg} alt="" aria-hidden="true" className="kb-bg kb-bg--cycle" />

          <div className="kb-badges">
            <span className="kb-badge">
              <IconPng name="ShieldCheck-2" size={28} />
            </span>
            <span className="kb-badge">
              <IconPng name="Rocket-2" size={28} />
            </span>
          </div>

          <h3 className="kb-title">Battle-Tested</h3>
          <p className="kb-desc">
            Building AI-centric products since 2023. We’ve shipped for Glovo,
            Genesis, Skelar — and already made the mistakes so you don’t have to.
          </p>
        </article>

        <article className="kb-card kb-anim kb-card--tall kb-card--outline kb-card--badge-tint">
          <div className="kb-badges">
            <span className="kb-badge">
              <IconPng name="CurrencyCircleDollar-2" size={28} />
            </span>
            <span className="kb-badge">
              <IconPng name="Speedometer-2" size={28} />
            </span>
          </div>

          <h3 className="kb-title">Cost Optimization</h3>
          <p className="kb-desc">
            AI projects get expensive fast. We’ve run the tests and know how to
            scale token costs, model selection, and infrastructure without
            breaking your unit economics.
          </p>
        </article>

        <button className="kb-cta kb-anim" onClick={() => setOpenModal(true)}>
          <span className="kb-cta__label">START YOUR PROJECT NOW</span>
          <img
            src={ctaBubble}
            alt=""
            className="kb-cta__bubble"
            aria-hidden="true"
          />
        </button>
      </div>

      

      <Modal
        open={openModal}
        onClose={() => setOpenModal(false)}
        title="Start your project"
      >
        <ContactFormSimple onSubmit={() => setOpenModal(false)} />
      </Modal>
    </section>
  );
}